import request from '@/utils/request';

// 来料加工明细
export function getMaterialDeliveryDetails(data) {
  return request({
    url: '/eos/materialDeliveryDetails/list',
    method: 'get',
    params: data,
  });
}
